import type { PropsWithChildren } from 'react'
import { createContext, useState } from 'react'

export { PageInfoProvider, PageInfoContext }

const PageInfoContext = createContext<{
  breadcrumbsSlot: HTMLElement | null
  setBreadcrumbsSlot: (element: HTMLElement | null) => void
} | null>(null)

const PageInfoProvider = ({ children }: PropsWithChildren) => {
  const [breadcrumbsSlot, setBreadcrumbsSlot] = useState<HTMLElement | null>(
    null,
  )

  return (
    <PageInfoContext.Provider value={{ breadcrumbsSlot, setBreadcrumbsSlot }}>
      {children}
    </PageInfoContext.Provider>
  )
}
